import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const VirtualTransactionsDownloadModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  downloadMode, submitted, bankAccountNumber,
  // event handlers
  onSubmit, onCancelClick,
  //
  format, onFormatChange, formatError, setFormatError, formatList
}) =>
  <ModalFormUI
    context={context}
    titleLabel={bankAccountNumber}
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='format' label='Format'
      value={format} onChange={onFormatChange} optionList={formatList}
      error={formatError} setError={setFormatError}
    />

  </ModalFormUI>

export default VirtualTransactionsDownloadModalUI
